<template>
  <div class="yuanzhu-website">
    <div class="layout-header">
      <div class="top">
        <div @click="handleLogo()">
          <img src="~/assets/logo.svg" style="height: 1rem" />
        </div>
        <div class="align-center" style="font-size: 0.24rem">
          <a-popover
            trigger="click"
            placement="bottom"
            class="mr-40rem"
            :visible="langVisible"
            @visibleChange="handleClickChange"
          >
            <template slot="content">
              <div :class="activeLang == 'zh' ? 'lang_box_active' : 'lang_box'" @click="changeLang('zh')">中文</div>
              <div :class="activeLang == 'en' ? 'lang_box_active' : 'lang_box'" @click="changeLang('en')">ENG</div>
            </template>
            <div>
              <img src="~/assets/lang.svg" style="width: 0.48rem; height: 0.48rem" />
            </div>
          </a-popover>
          <a-popover trigger="click" placement="bottom" :visible="tabVisible" @visibleChange="handleTabChange">
            <template slot="content">
              <div
                v-for="(item, index) in activeTab"
                :key="index"
                style="padding: 0.1rem 0; white-space: nowrap"
                @click="jumpPage(item)"
              >
                <div v-if="activeKey == item.key" style="color: #01afc8">
                  {{ item.name }}
                </div>
                <div v-else>{{ item.name }}</div>
              </div>
            </template>
            <img src="~/assets/menu.svg" style="width: 0.48rem; height: 0.48rem" />
          </a-popover>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <keep-alive :include="['home-mobile', 'house-mobile']">
        <router-view />
      </keep-alive>
    </div>
    <div v-if="['home-mobile'].includes(activeKey)" class="layout-footer">
      <img src="~/assets/logo_footer.svg" style="height: 1.85rem" />
      <div class="message_box">
        <div class="message_content align-center">
          <div>
            <img src="~/assets/weixin1.svg" />
          </div>
          <div class="ml-20">gaoxiaoyu5138</div>
          <textarea id="copyId" readonly tabindex="-1" aria-hidden="true">gaoxiaoyu5138</textarea>
          <div class="ml-20rem" @click="handleCopyText">
            <img src="~/assets/fuzhi.svg" />
          </div>
        </div>
        <div class="message_content">
          <img src="~/assets/phone1.svg" />
          <span class="ml-20rem">+62 812 8603 5248 /+86 13051888797</span>
        </div>
        <div class="message_content">
          <img src="~/assets/message1.svg" />
          <span class="ml-20rem">marketing@yardzeal.id</span>
        </div>
        <div class="message_content flex">
          <div>
            <img src="~/assets/loaction_footer1.svg" />
          </div>
          <div>
            <div
              v-for="(item, index) in commonAddresses"
              :key="index"
              class="ml-20rem address-line"
              :class="{ 'mt-10rem': index > 0 }"
            >
              <span>{{ item.country }}</span>
              <span class="address-divider">|</span>
              <span>{{ item.detail }}</span>
            </div>
            <div class="more-countries ml-20rem mt-10rem" @click="handleShowCountryAddress">
              <span>{{ $t('home.footer_more_countries') }}</span>
              <span class="more-countries-arrow">→</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="mr-40rem">
          <img src="~/assets/public_account.png" style="width: 1.78rem; height: 1.76rem" loading="lazy" decoding="async" />
          <div class="mt-20rem text-center">
            {{ $t('home.footer_public_account') }}
          </div>
        </div>
        <div class="mr-40rem">
          <img src="~/assets/weixin_video.svg" style="width: 1.77rem; height: 1.75rem" loading="lazy" decoding="async" />
          <div class="mt-20rem text-center">
            {{ $t('home.footer_weixin_video') }}
          </div>
        </div>
        <div>
          <img src="~/assets/tik_tok.svg" style="width: 1.73rem; height: 1.73rem" loading="lazy" decoding="async" />
          <div class="mt-20rem text-center">
            {{ $t('home.footer_tik_tok') }}
          </div>
        </div>
      </div>
      <div class="friendly_link">
        {{ $t('home.footer_links') }}
        <span @click="jumpShangMap">
          <img src="~/assets/shangmap1.svg" style="width: 0.28rem; height: 0.33rem" />
          <span style="color: #01afc8; vertical-align: middle">
            {{ $t('home.footer_shangmap') }}
          </span>
        </span>
      </div>
      <div class="footer_text">©YARD ZEAL INDONESIA, powered by SHANHAI MAP THX</div>
      <div class="footer_text" style="font-size: 0.22rem">
        Copyright <span style="font-size: 0.24rem">© www.yuanzhu-co.com</span> 源筑地产
      </div>
      <div class="footer_text" style="font-size: 0.22rem">
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025407399号-1</a>
      </div>
      <div class="footer_text">
        <img style="width: 0.18rem; margin-right: 0.1rem" src="~/assets/home/beian.png" />
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002006854" rel="noreferrer" target="_blank">
          粤公网安备44030002006854号
        </a>
      </div>
    </div>
    <CountryAddressMobile ref="countryAddressMobile" />
  </div>
</template>
<script>
import { i18n } from '~/plugins/i18n'
import { copyText } from '~/utils'
import { getCommonAddresses } from '~/utils/countryAddress'
import { isIOSDevice } from '~/utils/device'
import CountryAddressMobile from '~/components/countryAddressMobile.vue'
export default {
  name: 'mobile',
  components: { CountryAddressMobile },
  data() {
    return {
      activeKey: '',
      tabVisible: false,
      activeIndex: 0,
      langVisible: false,
      isIOS: false,
      activeLang: 'zh',
    }
  },
  created() {
    this.activeKey = this.$route.name
    this.activeLang = this.$i18n.locale
    i18n.locale = this.$i18n.locale
  },
  mounted() {
    this.isIOS = isIOSDevice()
  },
  computed: {
    commonAddresses() {
      return getCommonAddresses(this.$store.state.addressList)
    },
    activeTab() {
      return [
        {
          key: 'home-mobile',
          name: this.$t('home.home'),
          path: '/home/mobile',
        },
        {
          key: 'house-mobile',
          name: this.$t('detail.house_rent'),
          path: '/house/mobile',
        },
        {
          key: 'bpartner-mobile',
          name: 'B Partner',
          path: '/bpartner/mobile',
        },
        {
          key: 'about-mobile',
          name: this.$t('about.about'),
          path: '/about/mobile',
        },
      ]
    },
  },
  watch: {
    $route: function (newVal) {
      this.activeKey = this.$route.name
    },
  },
  methods: {
    jumpShangMap() {
      window.open('https://www.shanhaimap.com')
    },
    jumpPage(item) {
      this.activeKey = item.key
      this.tabVisible = false
      this.$router.push({ path: item.path })
    },
    handleTabChange(visible) {
      this.tabVisible = visible
    },
    handleClickChange(visible) {
      this.langVisible = visible
    },
    async handleCopyText() {
      const textarea = document.getElementById('copyId')
      const text = (textarea && textarea.value) || 'gaoxiaoyu5138'
      const result = await copyText(text)
      if (result.ok) {
        this.$message.success(this.$t('home.footer_weixin_copy_success'))
      } else if (result.error === 'exec_failed') {
        this.$message.success(this.$t('home.footer_weixin_copy_fail'))
      } else {
        this.$message.success(this.$t('home.footer_weixin_copy_not'))
      }
    },
    changeLang(type) {
      this.$i18n.locale = type
      localStorage.setItem('locale', type)
      this.activeLang = type
      this.langVisible = false
      window.location.reload()
    },
    handleShowCountryAddress() {
      this.$refs.countryAddressMobile.show()
    },
    handleLogo() {
      window.location.reload(true)
      window.location.href = '/home-mobile'
    },
  },
}
</script>
<style>
html {
  font-size: calc(100vw / 7.5) !important;
  overflow-x: hidden;
}
body {
  max-width: 100%;
}
</style>
<style lang="less" scoped>
.yuanzhu-website {
  font-family: PingFang SC, PingFang SC;
}
.layout-header {
  width: 100%;
  max-width: 7.5rem;
  height: 1.13rem;
  color: #000000;
  background: #ffffff;
  position: fixed;
  top: 0;
  z-index: 999;
  .top {
    width: 100%;
    height: 1.13rem;
    padding: 0 0.32rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.lang_box {
  padding: 0.1rem 0;
}
.lang_box_active {
  padding: 0.1rem 0;
  color: #01afc8;
}
.layout-content {
  width: 100%;
  max-width: 7.5rem;
  background: #f3f4f9;
  color: #000000;
  margin-top: 1.13rem;
}
.layout-footer {
  width: 100%;
  max-width: 7.5rem;
  background: #232c46;
  color: #fff;
  padding: 0.8rem 0;
  padding-left: 0.64rem;
  padding-right: 0.49rem;
  font-size: 0.24rem;
  .message_box {
    color: #ffffff;
    margin-top: 0.4rem;
    margin-bottom: 0.8rem;
    font-size: 0.26rem;
    .message_content {
      padding: 0.1rem 0;
      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .address-line {
    font-size: 0.24rem;
    line-height: 1.6;
    word-break: break-word;
    .address-divider {
      margin: 0 0.1rem;
    }
  }
  .more-countries {
    display: inline-flex;
    align-items: center;
    color: #01afc8;
    cursor: pointer;
    font-size: 0.24rem;
    user-select: none;
    .more-countries-arrow {
      margin-left: 0.08rem;
    }
  }
  .friendly_link {
    text-align: center;
    margin-top: 0.65rem;
  }
  .footer_text {
    color: #acafb9;
    margin-top: 0.26rem;
    text-align: center;
    font-size: 0.2rem;
  }
}
#copyId {
  opacity: 0;
  width: 0;
  height: 0;
}
</style>
